/*******************************************************************************
* Copyright (c) 2025 Bula Technologies
*
* All rights reserved.
*
* Contributors:
*  James Worthington - Initial implementation
*  Amina Rais - Massive Improvements
*  Version: 1.0.0
*
*******************************************************************************/

export const TimestampToDate = (timestamp) => {
    const createdTimestamp = timestamp;
    const formattedDate = new Date(createdTimestamp).toLocaleString(); 

    return formattedDate;
};

 export const formatFirestoreTimestamp = (timestamp) => {
  if (!timestamp) return "-";
  try {
    if (timestamp.toDate) {
      // Firestore Timestamp
      return timestamp.toDate().toLocaleString();
    } else if (timestamp._seconds || timestamp.seconds) {
      // From Cloud Function (Admin SDK)
      const secs = timestamp._seconds || timestamp.seconds;
      return new Date(secs * 1000).toLocaleString();
    } else if (typeof timestamp === "string" || typeof timestamp === "number") {
      // Already serialized or numeric
      return new Date(timestamp).toLocaleString();
    }
  } catch (e) {
    console.error("Invalid timestamp:", timestamp, e);
  }
  return "-";
};
